import { httpService } from './api/http';
import { resolveGatewayBackedServiceBaseUrl } from './serviceBaseUrl';

const OBJECT_SERVICE_API_BASE = resolveGatewayBackedServiceBaseUrl(
    process.env.REACT_APP_OBJECT_SERVICE_URL,
);

const UOM_ENDPOINTS = Object.freeze({
    CURRENT_USER_OBJECT: `${OBJECT_SERVICE_API_BASE}/api/objects/v1/users/me/object`,
});

async function getCurrentUserObject(options = {}) {
    return httpService.get(UOM_ENDPOINTS.CURRENT_USER_OBJECT, options);
}

async function ensureCurrentUserObject(options = {}) {
    return httpService.post(UOM_ENDPOINTS.CURRENT_USER_OBJECT, undefined, options);
}

export const uomService = Object.freeze({
    endpoints: UOM_ENDPOINTS,
    ensureCurrentUserObject,
    getCurrentUserObject,
});
